import { render, staticRenderFns } from "./skillsCompareModal.vue?vue&type=template&id=856b5ece&"
import script from "./skillsCompareModal.vue?vue&type=script&lang=js&"
export * from "./skillsCompareModal.vue?vue&type=script&lang=js&"
import style0 from "./skillsCompareModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports